/**
 * Reusable JSON-LD builders. Keep values conservative — do not claim
 * services or offerings the company does not actually provide.
 */

export const SITE_URL = 'https://agencive.fi';

export const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Agencive AI Oy',
  legalName: 'Agencive AI Oy',
  taxID: '3590217-8',
  url: SITE_URL,
  logo: `${SITE_URL}/brand/agencive/transparent/logo-horizontal-black-transparent.png`,
  email: 'agencive.ai@gmail.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Lempäälä',
    addressRegion: 'Pirkanmaa',
    addressCountry: 'FI',
  },
  founders: [
    { '@type': 'Person', name: 'Lenni Marttila' },
    { '@type': 'Person', name: 'Anton Ovaskainen' },
    { '@type': 'Person', name: 'Eetu Tuominen' },
  ],
};

export const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Agencive',
  url: SITE_URL,
  inLanguage: 'fi-FI',
};

export const serviceLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Brändiagentti — AI-hahmo somesisällöissä ja verkkosivun agentissa',
  provider: { '@type': 'Organization', name: 'Agencive AI Oy', url: SITE_URL },
  areaServed: { '@type': 'Country', name: 'Finland' },
  description:
    'Brändiin räätälöity AI-hahmo, joka toimii samana persoonana somesisällöissä ja asennettuna asiakkaan olemassa olevalle verkkosivustolle.',
  url: `${SITE_URL}/palvelut`,
};

export const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const faqLd = (qas) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: qas.map((qa) => ({
    '@type': 'Question',
    name: qa.q,
    acceptedAnswer: { '@type': 'Answer', text: qa.a },
  })),
});
